import { render, staticRenderFns } from "./ChatServiceSvg.vue?vue&type=template&id=eab25196&"
import script from "./ChatServiceSvg.vue?vue&type=script&lang=js&"
export * from "./ChatServiceSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports